// extracted by mini-css-extract-plugin
module.exports = {"diets":"Presentation_diets__3hwSI","readyContainer":"Presentation_readyContainer__2LiaA"};